module.exports = __webpack_public_path__ + "zarustajici-nehty_2_after.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/llc/surgery/procedures/obecna-a-zilni-chirurgie/zarustajici-nehty_2_after.jpg
// module id = 1039
// module chunks = 0